<script lang="ts">
    import wishlist from '../store/wishlist';
    import Wishlist from './wishlist/Wishlist.svelte';

    let count = wishlist.count;

    $: count, wishlist.init();

    let show = false;

    const hide = () => {
        show = false;
    };
</script>

<div class="cart-wrapper">
    {#if show == true}
        <Wishlist {hide} />
    {/if}

    <button class="cart-info" on:click={() => (show = !show)}>
        {#if $count > 0}
            <div class="cart-count">{$count}</div>
        {/if}
        <i class="fas fa-shopping-basket" />
    </button>
</div>

<style>
    .cart-info {
        height: 60px;
        width: 60px;
        background-color: #dba924;
        border-radius: 30px;
        border: 1px solid #dba924;
        font-size: 30px;
        line-height: 20px;
        padding: 14px 12px;
        color: white;
        cursor: pointer;
        position: relative;
        margin-right: 50px;
        margin-bottom: 10px;
        float: right;
        display: inline-block;
        box-shadow: 0px 1px 1px rgb(0 0 0 / 25%), 0 5px 5px rgb(0 0 0 / 22%);
        transition: all 0.3s;
    }

    @media screen and (max-width: 800px) {
        .cart-info {
            margin-right: 20px;
        }
    }

    .cart-info:hover {
        background-color: #eab743;
        font-size: 35px;
        padding: 5px;
        transition: all 0.3s;
    }

    .cart-wrapper {
        position: fixed;
        bottom: 5px;
        right: 10px;
        z-index: 2001;
        width: 94vw;
        max-width: 340px;

        display: inline-block;
        width: auto;
    }
    .cart-count {
        position: absolute;
        top: 1px;
        right: -2%;
        height: 20px;
        line-height: 20px;
        width: 20px;
        background-color: red;
        border-radius: 20px;
        color: white;
        font-family: inherit;
        text-align: center;
        font-size: 0.7rem;
    }
</style>
